export const KEYS = {
    SP_EDITOR_CONTAINER: 'sp-editor-container',
    SP_CONTENT_EDITABLE: 'sp-contenteditable',
    SP_PDF_CONTENT: 'sp-pdf-content',
    ST_CONTENT_EDITABLE: 'st-contenteditable',
    ST_EDITOR_CONTAINER: 'st-editor-container',
}
